export default "__VITE_ASSET__de476dc2__"